// src/components/NewsletterForm.tsx
import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { toast } from 'react-toastify';

interface NewsletterFormData {
  email: string;
}

export default function NewsletterForm() {
  const { 
    register, 
    handleSubmit, 
    formState: { isSubmitting, errors } 
  } = useForm<NewsletterFormData>();

  const onSubmit: SubmitHandler<NewsletterFormData> = async (data) => {
    try {
      const response = await fetch('/api/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) throw new Error();
      toast.success('🎉 Thanks for subscribing!');
    } catch (error) {
      toast.error('❌ Subscription failed. Please try again.');
    }
  };

  return (
    <div className="bg-gradient-to-br from-blue-900 to-purple-900 p-6 rounded-xl shadow-xl">
      <h3 className="text-2xl font-bold mb-4 text-white">Get AI Dev Insights</h3>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
        <input
          {...register('email', { 
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address'
            }
          })}
          type="email"
          placeholder="Your professional email"
          className="w-full p-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        {errors.email && (
          <p className="text-red-300 text-sm">{errors.email.message}</p>
        )}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-50"
        >
          {isSubmitting ? 'Submitting...' : 'Join Newsletter'}
        </button>
      </form>
      <p className="mt-4 text-sm text-white/70">
        No spam • Unsubscribe anytime • GDPR compliant
      </p>
    </div>
  );
}